import { axiosClient } from './axiosClient.service'

export function tokenSet(token: string) {
  axiosClient.defaults.headers['Authorization'] = `Bearer ${token}`
}

export function tokenReset() {
  axiosClient.defaults.headers['Authorization'] = null
}
